const sp2Links = {
  BrownEtAlChestLink: 'https://pubmed.ncbi.nlm.nih.gov/26836924/',
};

export { sp2Links };
